var ns;
ns.App.factory('StockQualitiesService', function(
  HttpFactory, API_ENDPOINT, DsFactory, Utils, $http
  ){
  return {
    getStockQualitiesData: function(){
      var endpoint = API_ENDPOINT + '/stock_qualities';
      return HttpFactory.createGet(endpoint);
    },
    //FN_50010 品質区分登録
    //登録　or 更新
    storeOrUpdateForStockQuality: function(params){
      var endpoint = API_ENDPOINT + '/stock_qualities';
      return HttpFactory.createPost(endpoint, params);
    },
    //削除
    deleteForStockQuality: function(id){
      var endpoint = API_ENDPOINT + '/stock_qualities/' + id;
      return $http.delete(endpoint);
    },
  };
});

